import { gql } from '@/__generated__/gql'

export const CommonContentFragment = gql(`
  fragment Common_ContentFragment on Content {
    id
    contentId
    contentType
    published
    publishedAtDate
    createdAt
    updatedAt
    title
    path
    shortDescription
    description
    language
    contentPolicyPolicyId
    ...Common_ContentProviderFragment
  }
`)
